;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { TIER_TIMEZONE } from "@/lib/services/tier/tier-constants";

export interface LaDateParts {
	year: number;
	month: number;
	day: number;
}

function getLaDateParts(date: Date): LaDateParts {
	const formatted = new Intl.DateTimeFormat("en-US", {
		day: "2-digit",
		month: "2-digit",
		timeZone: TIER_TIMEZONE,
		year: "numeric",
	}).formatToParts(date);

	const parts = Object.fromEntries(
		formatted.map((part) => [part.type, part.value]),
	);

	return {
		day: Number(parts.day),
		month: Number(parts.month),
		year: Number(parts.year),
	};
}

function getLaTimeParts(date: Date): {
	year: number;
	month: number;
	day: number;
	hour: number;
	minute: number;
} {
	const formatted = new Intl.DateTimeFormat("en-US", {
		day: "2-digit",
		hour: "2-digit",
		hourCycle: "h23",
		minute: "2-digit",
		month: "2-digit",
		timeZone: TIER_TIMEZONE,
		year: "numeric",
	}).formatToParts(date);

	const parts = Object.fromEntries(
		formatted.map((part) => [part.type, part.value]),
	);

	return {
		day: Number(parts.day),
		hour: Number(parts.hour),
		minute: Number(parts.minute),
		month: Number(parts.month),
		year: Number(parts.year),
	};
}

function addCalendarDays(parts: LaDateParts, days: number): LaDateParts {
	const anchor = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
	anchor.setUTCDate(anchor.getUTCDate() + days);
	return getLaDateParts(anchor);
}

/** Start of a Pacific calendar day as a UTC instant. */
export function pacificStartOfDay(parts: LaDateParts): Date {
	const probeStart = Date.UTC(
		parts.year,
		parts.month - 1,
		parts.day - 1,
		0,
		0,
		0,
	);
	const probeEnd = Date.UTC(
		parts.year,
		parts.month - 1,
		parts.day + 1,
		0,
		0,
		0,
	);

	for (let instant = probeStart; instant <= probeEnd; instant += 60_000) {
		const current = new Date(instant);
		const la = getLaTimeParts(current);
		if (
			la.year === parts.year &&
			la.month === parts.month &&
			la.day === parts.day &&
			la.minute === 0 &&
			(la.hour === 0 || la.hour === 24)
		) {
			return current;
		}
	}

	throw new Error(
		`Could not resolve Pacific start of day for ${parts.year}-${parts.month}-${parts.day}`,
	);
}

/** End of a Pacific calendar day (23:59:59.999) as a UTC instant. */
export function pacificEndOfDay(parts: LaDateParts): Date {
	const nextDay = addCalendarDays(parts, 1);
	const nextDayStart = pacificStartOfDay(nextDay);
	return new Date(nextDayStart.getTime() - 1);
}

/**
 * First instant the trial is over (exclusive end): Pacific start-of-day on the
 * calendar day after the last included trial day.
 */
export function computeTierExpiresAt(
	connectedAt: Date,
	tierDurationDays: number,
): Date {
	const connectionDay = getLaDateParts(connectedAt);
	const lastTrialDay = addCalendarDays(connectionDay, tierDurationDays);
	return pacificStartOfDay(addCalendarDays(lastTrialDay, 1));
}

/**
 * Last inclusive Pacific calendar day of trial access for a stored expiresAt.
 * Handles new start-of-day boundaries and legacy end-of-day (-1ms) rows.
 */
export function getFreemiumTrialLastDayParts({
	expiresAt,
}: {
	expiresAt: Date;
}): LaDateParts {
	const expiryDay = getLaDateParts(expiresAt);
	if (expiresAt.getTime() === pacificStartOfDay(expiryDay).getTime()) {
		return addCalendarDays(expiryDay, -1);
	}

	return expiryDay;
}
